import {AuthPayload} from "../../common/auth";
import { IOrganisation } from "../../common/organisation";
import {USER_ROLES} from "../../consts/user";
import {ACTION_TYPES as ORGANISATION_ACTIONTYPES} from "../organisation/types";
export type InitialState = {
    role: USER_ROLES[];
    name?: string;
    token?: string;
    organisation?: IOrganisation;
}

export const enum ACTION_TYPES {
    LOGIN = 'login',
    REGISTER = 'register',
    LOGIN_SUCCESS = 'loginSuccess',
    LOGIN_ERROR = 'loginError',
    LOGOUT = 'logOut',
};

export type Actions = {
    type: ACTION_TYPES | ORGANISATION_ACTIONTYPES,
    payload: AuthPayload,
};